import {Component, OnInit} from '@angular/core';
import {AboutService} from '../../../services/about.service';
import {AboutDTO} from '../../../models/AboutDTO';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-support-view',
  templateUrl: './support-view.component.html',
  styleUrls: [
    './support-view.component.css',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class SupportViewComponent implements OnInit {

  aboutInformation = new AboutDTO();
  serviceDeskUrl = environment.serviceDeskRequestsUrl;

  constructor(private aboutService: AboutService) {
  }

  ngOnInit(): void {
    this.getLatestAboutInformation();
  }

  getLatestAboutInformation(): void {
    this.aboutService.getLatest().subscribe(
      response => {
        this.aboutInformation = response;
      }
    );
  }

  goToLink(url: string): void {
    window.open(url, "_blank");
  }

  aboutInformationIsEmpty(): boolean {
    return Object.keys(this.aboutInformation).length === 0;
  }

}
